<app-static-text [key]="termsConditionsKey" *ngIf="termsConditionsKey"></app-static-text>
